export const environment = {
  production: false,
  mockApi: false,
  useTestAuthToken: false,
  apiBaseUrl: '__API_BASE_URL__',
  widgetApiBaseUrl: '__WIDGET_API_BASE_URL__',
  streamBaseUrl: '__STREAM_BASE_URL__',
  apiWsBaseUrl: '__API_WS_BASE_URL__',
  appBaseUrl: 'https://app-qa.rozieaijourney.com',
  widgetAppBaseUrl: 'https://journey-qa.rozie.ai',
  /** MCP Server URL - custom domain via CloudFront. */
  mcpBaseUrl: 'https://mcp.app-qa.rozieaijourney.com/mcp',
  cognito: {
    region: 'us-east-1',
    userPoolId: '__COGNITO_USER_POOL_ID__',
    clientId: '__COGNITO_CLIENT_ID__',
    autoConfirmSignUp: false,
  },
  tenantIds: ['__TENANT_ID__'],
  platformLibraryTenantId: '__PLATFORM_LIBRARY_TENANT_ID__',
  /** Analytics dashboard limits, matching how long this environment keeps the data
   * (journey2-backend sessionRetentionDays, journey2-analytics raw-event TTL). */
  analytics: {
    retentionDays: 30,
    customRangeMaxDays: 31,
    customRangeLookbackDays: 60,
  },
  askAssistance: {
    apiPrefix: '/api/v1/journey-assistance',
  },
};
